import Brand from "./Brand";
import Category from "./Category";
import Shop from "./Shop";
import UOM from "./UOM";

const Others = () => {
    return (
        <>
            <div className="grid">
                <div className="col-12 md:col-6">
                    <Shop />
                </div>
                <div className="col-12 md:col-6">
                    <UOM />
                </div>
            </div>

            <div className="grid">
                <div className="col-12 md:col-6">
                    <Category />
                </div>
                <div className="col-12 md:col-6">
                    <Brand />
                </div>
            </div>
        </>
    )
}

export default Others;